export const mapOvertimeAccountDto = (dto) => ({
    id: dto.id,
    userId: dto.userId,
    year: dto.year,
    month: dto.month,
    plannedTime: dto.plannedTime,
    actualTime: dto.actualTime,
    overtime: dto.overtime,
    manualCorrection: dto.manualCorrection,
    finalBalance: dto.finalBalance,
    displayName: dto.user.name,

});

export const mapTotalOvertimeBalance = (dto) => ({
    userId: dto.userId,
    totalBalance: dto.totalBalance,
    monthlyDetails: dto.monthlyDetails
});